import { render, staticRenderFns } from "./ClientArchiveModal.vue?vue&type=template&id=7bdee1c6"
import script from "./ClientArchiveModal.vue?vue&type=script&lang=ts"
export * from "./ClientArchiveModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports